const getChildNodes = (element: Element) => {
  if (element.shadowRoot) {
    return element.shadowRoot.childNodes;
  }

  return element.nodeName === 'SLOT'
    ? (<HTMLSlotElement>element).assignedElements()
    : element.childNodes;
};

export function deepQuerySelectorAll(
  query: string,
  element: Element = document.body,
) {
  const result: Array<Element> = Array.from(getChildNodes(element))
    .filter(
      (element: ChildNode): element is Element => element instanceof Element,
    )
    .map((element: Element) => deepQuerySelectorAll(query, element))
    .flat();

  if ((<Element>element).matches?.(query)) {
    result.push(<Element>element);
  }

  return result;
}
